import(/* webpackMode: "eager", webpackExports: ["Newsletter"] */ "/opt/atlassian/pipelines/agent/build/apps/d2c-web/app/[country]/[lang]/company/newsletter/components/newsletter.tsx");
